// _services/competitorsService.js
import api from '../../../api/axios';

export const competitorsService = {
  /**
   * Obtener competidores
   */
  getCompetitors: async (slug) => {
    const response = await api.get(`/competitors/${slug}`);
    return response.data;
  },

  /**
   * Obtener columnas visibles
   */
  getVisibleColumns: async (slug) => {
    const response = await api.get(`/competitors/${slug}/visible-columns`);
    return response.data;
  },

  /**
   * Guardar columnas visibles
   */
  saveVisibleColumns: async (slug, visibleColumns, publicListEnabled) => {
    
    const response = await api.post(`/competitors/${slug}/visible-columns`, {
      visibleColumns: visibleColumns,
      publicListEnabled: publicListEnabled
    });
    return response.data;
  },

  /**
   * Agregar competidor
   */
  addCompetitor: async (slug, data) => {
    const response = await api.post(`/competitors/${slug}`, data);
    return response.data;
  },

  /**
   * Editar competidor
   */
  editCompetitor: async (slug, id, data) => {
    const response = await api.put(`/competitors/${slug}/${id}/edit`, data, {
      timeout: 30000
    });
    return response.data;
  },

  /**
   * Eliminar competidor
   */
  deleteCompetitor: async (slug, id) => {
    const response = await api.delete(`/competitors/${slug}/${id}`);
    return response.data;
  },

  /**
   * Descargar excel
   */
  downloadExcel: async (slug, columns) => {
    const response = await api.post(
      `/competitors/${slug}/download`,
      { columns },
      { responseType: 'blob' }
    );
    return response.data;
  }
};